


































import Vue from 'vue';
import { formatDateTime } from '@/utils/tools';
import { HollowDotsSpinner } from 'epic-spinners';
import { mapGetters } from 'vuex';
import ThemeModel from '@/dtos/theme';

export default Vue.extend({
  components: { HollowDotsSpinner },
  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      activeSession: 'viewer/getActiveSession',
      sessionTheme: 'viewer/getSessionTheme',
    }),
    theme(): ThemeModel {
      return this.sessionTheme as ThemeModel;
    },
  },
  methods: {
    formatDateTime(input: any): string {
      return formatDateTime(input);
    },
  },
});
